export default __webpack_public_path__ + "static/media/Group1.d2673f9f.svg";